import React from 'react';

import APFormGroup from 'components/FormFields/APFormGroup';
import FormTextarea from 'components/FormFields/FormTextarea';
import LeadRecordCustomFields from './LeadRecordCustomFields';

const LeadRecordNotes = ({
  orgId,
  leadId,
  notes,
  updateNotes,
  userDefinedFields,
}) => {
  return (
    <div className="lead-record-notes">
      <APFormGroup>
        <FormTextarea
          name="Notes"
          labelHidden
          defaultValue={notes}
          onBlur={(e) => updateNotes(e.target.value)}
          placeholder="Add any notes you'd like about this lead."
        />
      </APFormGroup>

      <LeadRecordCustomFields
        orgId={orgId}
        leadId={leadId}
        userDefinedFields={userDefinedFields}
      />
    </div>
  );
};

export default LeadRecordNotes;
